import React from "react";
import Link from "gatsby-link";
import { log } from "util";

export default ({ group }) => {

  return (
    <section>
      {(group).map(({ node }) => {
        const { id, frontmatter, fields, excerpt } = node;
        
        return (
          <article className="post" key={id}>
            <h3>
              <Link
                to={`/${fields.slug}`}
              >
                {frontmatter.title}
              </Link>
            </h3>
            <p>{excerpt}</p>
            <p className="post-date">{frontmatter.date}</p>
          </article>
        );
      })}
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/templates/blog-posts.js